
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1600 900"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#00e718","stroke":"#000","stroke-miterlimit":"10","d":"M-34-32h1665v962H-34z"}}),_c('path',{attrs:{"fill":"none","d":"M171 270h423v198H171z"}}),_c('text',{attrs:{"transform":"translate(171 411.998)","font-size":"200","font-family":"MyriadPro-Regular"}},[_v('4')]),_c('path',{attrs:{"d":"M1085.7 761.3c-34.3-12.2-83.6-16.5-115-23.4-18.1-4-44.5-14.1-53.2-24.5-8.8-10.6-3.5-108.9-3.5-108.9s16.2-25.6 25-47.9c8.8-22.4 18.4-83.6 18.4-83.6s18.1 0 24.5-31.7c6.9-34.6 17.6-49 16.2-74.8-1.3-24-13.8-25.3-15.2-25.3 0 0 13-36.2 14.9-112.9C1000 137.5 930.5 48 800 48s-199.7 89.2-197.8 180c1.6 76.4 14.9 112.9 14.9 112.9-1.3 0-13.8 1.3-15.2 25.3-1.3 25.8 9.6 39.7 16.2 74.3 6.4 31.7 24.5 32 24.5 32s9.6 61.5 18.4 83.9c8.8 22.6 25 47.9 25 47.9s5.3 98.2-3.5 108.9-35.1 20.5-53.2 24.5c-31.7 6.9-80.7 11.4-115 23.7C480 773.5 374 814.8 374 900h852c0-85.2-106-126.5-140.3-138.7z"}})])
          )
        }
      }
    